module.exports = __webpack_public_path__ + "static/media/front_phones_1.b702f16d.png";